import { render, staticRenderFns } from "./CompanyNoticeNew.vue?vue&type=template&id=b52ddb70&scoped=true&lang=pug&"
import script from "./scripts/CompanyNoticeNew.js?vue&type=script&lang=js&"
export * from "./scripts/CompanyNoticeNew.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52ddb70",
  null
  
)

export default component.exports